export default {"src":"/_next/static/media/Mapemonde.6983f8f8.svg","height":393,"width":770};